import { Skeleton, SkeletonCircle, SkeletonText } from "@chakra-ui/react";
import DefaultBannerImage from "../../assets/default_banner.jpg";
import { createIpfsImageUrl } from "common/src/ipfs";
import { getConfig } from "common/src/config";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProjectBanner(props) {
  var _props$classNameOverr;
  const {
    ipfs: {
      baseUrl: ipfsBaseUrl
    }
  } = getConfig();
  const projectBannerImageUrl = props.bannerImgCid ? createIpfsImageUrl({
    baseUrl: ipfsBaseUrl,
    cid: props.bannerImgCid,
    height: props.resizeHeight ? props.resizeHeight * 2 : undefined
  }) : DefaultBannerImage;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("img", {
      className: (_props$classNameOverr = props.classNameOverride) !== null && _props$classNameOverr !== void 0 ? _props$classNameOverr : "h-[120px] w-full object-cover rounded-t",
      src: projectBannerImageUrl,
      alt: "Project Banner"
    })
  });
}
export function ProjectLogo(props) {
  var _props$className;
  const {
    ipfs: {
      baseUrl: ipfsBaseUrl
    }
  } = getConfig();
  const projectLogoImageUrl = createIpfsImageUrl({
    baseUrl: ipfsBaseUrl,
    cid: props.imageCid,
    height: props.size * 2
  });
  return /*#__PURE__*/_jsx("img", {
    className: `object-cover rounded-full ${(_props$className = props.className) !== null && _props$className !== void 0 ? _props$className : ""}`,
    style: {
      height: props.size,
      width: props.size
    },
    src: projectLogoImageUrl,
    alt: "Project Banner"
  });
}
export function CardSkeleton() {
  return /*#__PURE__*/_jsxs("div", {
    className: "bg-white rounded-3xl overflow-hidden p-4 pb-10",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      height: "110px"
    }), /*#__PURE__*/_jsx(SkeletonCircle, {
      size: "48px",
      mt: "-24px",
      ml: "10px"
    }), /*#__PURE__*/_jsx(SkeletonText, {
      mt: "3",
      noOfLines: 1,
      spacing: "4",
      skeletonHeight: "7"
    }), /*#__PURE__*/_jsx(SkeletonText, {
      mt: "10",
      noOfLines: 4,
      spacing: "4",
      skeletonHeight: "2"
    })]
  });
}